import { Checkbox, TableCell, TableRow } from "@mui/material"

function TableRowDynamic({ entity, columns, actions, loaded, isItemSelected, onSelectOneClick }) {
  const labelId = `enhanced-table-checkbox-${entity.id.answer}`;

  return (
    <>
      <TableRow
        hover
        onClick={(event) => onSelectOneClick(event, entity.id.answer)}
        role={onSelectOneClick && "checkbox"}
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={entity.id.answer}
        selected={isItemSelected}
        sx={{ cursor: 'pointer', '&:last-child td, &:last-child th': { border: 0 } }}
      >
        {onSelectOneClick &&
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              checked={isItemSelected}
              inputProps={{
                'aria-labelledby': labelId,
              }}
            />
          </TableCell>
        }
        {columns.map((column, index) => (
          <TableCell
            key={index}
            align="center"
            component="th"
            id={labelId}
            scope="row"
            padding="none"
          >
            {entity[column.id]?.answer || entity[column.id]?.answer == '0' ? entity[column.id]?.answer : '-'}
          </TableCell>
        ))}
        {loaded &&
          <TableCell align="center" p={0}>
            {actions}
          </TableCell>
        }
      </TableRow>
    </>
  );
}

export default TableRowDynamic